export default __webpack_public_path__ + "a455f4dc8891eb8ef33edd18e61cb898.svg";